export type BankFieldRequirements = {
	bsb: boolean;
	abaRoutingNumber: boolean;
	branchCode: boolean;
	branchName: boolean;
	swiftBic: boolean;
};

const NO_ADDITIONAL_FIELDS: BankFieldRequirements = {
	bsb: false,
	abaRoutingNumber: false,
	branchCode: false,
	branchName: false,
	swiftBic: false,
};

const BRANCH_AND_SWIFT: BankFieldRequirements = {
	...NO_ADDITIONAL_FIELDS,
	branchCode: true,
	branchName: true,
	swiftBic: true,
};

export const MVP_BANK_REQUIREMENTS: Record<string, BankFieldRequirements> = {
	AU: { ...NO_ADDITIONAL_FIELDS, bsb: true, swiftBic: true },
	PH: BRANCH_AND_SWIFT,
	TH: BRANCH_AND_SWIFT,
	MY: BRANCH_AND_SWIFT,
	ID: BRANCH_AND_SWIFT,
	VN: BRANCH_AND_SWIFT,
	SG: { ...NO_ADDITIONAL_FIELDS, branchCode: true, branchName: true, swiftBic: true },
	US: { ...NO_ADDITIONAL_FIELDS, abaRoutingNumber: true, swiftBic: true },
};

export const getBankFieldRequirements = (country: string): BankFieldRequirements =>
	MVP_BANK_REQUIREMENTS[country.toUpperCase()] ?? NO_ADDITIONAL_FIELDS;

export const getBankRequirementsDescription = (country: string): string => {
	const requirements = getBankFieldRequirements(country);
	if (requirements.bsb) return "Your selected country requires a BSB Number.";
	if (requirements.abaRoutingNumber) return "Your selected country requires an ABA Routing Number.";
	if (requirements.swiftBic) {
		return "Your selected country requires a Branch Code, Branch Name, and BIC/SWIFT Code.";
	}
	if (requirements.branchCode) return "Your selected country requires a Branch Code and Branch Name.";
	return "No additional country-specific bank fields are included for this market in MVP.";
};
